// extracted by mini-css-extract-plugin
export default {"container":"TableActive_container__4NcAd","cellUser":"TableActive_cellUser__YfRM7","cellInfo":"TableActive_cellInfo__qqEC9","cellData":"TableActive_cellData__se3u-"};